import LoadingContainer from './styles/';

export default function Loading() {
  return (
    <LoadingContainer>
      <h2>Loading...</h2>
    </LoadingContainer>
  );
}
